(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleController', VentadetalleController);

    VentadetalleController.$inject = [
		"$scope",
		"$filter",
		"$state",
		"Ventadetalle",
		"VentadetalleFecha",
		"ParseLinks",
		"AlertService"
		];

    function VentadetalleController($scope,  $filter, $state, Ventadetalle, VentadetalleFecha,  ParseLinks,  AlertService) {
        var vm = this;
		vm.transition = transition;
		vm.fromDate = null;
		vm.toDate = null;
		vm.onChangeDate = onChangeDate;
		vm.previousMonth = previousMonth;
		vm.today = today;
        vm.listaComercios = null;
		vm.seleccionComercio = "<Todos>";
		vm.arrayComercios = null;
		vm.totalizado= 0;

		vm.toDate=JSON.parse( sessionStorage.getItem( 'ventasdetallefechahasta'), dateReviver );
		vm.fromDate=JSON.parse( sessionStorage.getItem( 'ventasdetallefechadesde'), dateReviver );
		if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
			vm.today();	
		}
		if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
			vm.previousMonth();
		}
		//
		vm.onChangeDate();
		//
		$scope.today = function() {
		  $scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function() {
		  $scope.dt = null;
		};

		$scope.inlineOptions = {
		  customClass: getDayClass,
		  minDate: new Date(),
		  showWeeks: true
		};

		//aca llamaban a disabled para sacar los weekends...
		$scope.dateOptions = {
		  formatYear: "yy",
		  maxDate: new Date(2040, 12, 31),
		  minDate: new Date(2018, 8, 1),
		  startingDay: 1
		};

		// Disable weekend selection (no lo usamos!)
		function disabled(data) {
		  var date = data.date,
			mode = data.mode;
		  return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
		}

		$scope.toggleMin = function() {
		  $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
			? null
			: new Date();
		  $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
		};

		$scope.toggleMin();

		$scope.open1 = function() {
		  $scope.popup1.opened = true;
		};

		$scope.open2 = function() {
		  $scope.popup2.opened = true;
		};

		$scope.setDate = function(year, month, day) {
		  $scope.dt = new Date(year, month, day);
		};

		$scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
		$scope.format = $scope.formats[0];
		$scope.altInputFormats = ["M!/d!/yyyy"];

		$scope.popup1 = {   opened: false  };

		$scope.popup2 = {   opened: false  };

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		$scope.events = [
		  {
			date: tomorrow,
			status: "full"
		  },
		  {
			date: afterTomorrow,
			status: "partially"
		  }
		];

		function getDayClass(data) {
		  var date = data.date,
			mode = data.mode;
		  if (mode === "day") {
			var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

			for (var i = 0; i < $scope.events.length; i++) {
			  var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

			  if (dayToCheck === currentDay) {
				return $scope.events[i].status;
			  }
			}
		  }

		  return "";
		}

		
		function onChangeDate() {
		  var dateFormat = "yyyy-MM-dd";
		  var fromDate = $filter("date")(vm.fromDate, dateFormat);
		  var toDate = $filter("date")(vm.toDate, dateFormat);

		  if (fromDate > toDate) {
			AlertService.error(
			  "Fecha Hasta debe ser mayor o igual que Fecha Desde"
			);
			return false;
		  }
		  
		  sessionStorage.setItem( 'ventasdetallefechadesde', JSON.stringify(new Date(vm.fromDate)));
		  sessionStorage.setItem('ventasdetallefechahasta', JSON.stringify(new Date(vm.toDate)));
		  
		  //aca llama al service.js y de ahi al WS backend
		  VentadetalleFecha.query(
			{ fromDate: fromDate, toDate: toDate },
			function(result) {
				vm.totalizado=0;
				vm.listaComercios= new Map();
				result.forEach(function(vtadia){
						vm.totalizado += 1;
						if(!vm.listaComercios.has(vtadia.comercio)){				//https://codeburst.io/javascript-array-distinct-5edc93501dc4
							vm.listaComercios.set(vtadia.comercio, true);    // set any value to Map
							}
						})  
				vm.arrayComercios = Array.from(vm.listaComercios.keys());//console.log(vm.arrayComercios);
				vm.arrayComercios.sort();
				vm.arrayComercios.unshift("<Todos>");
				vm.ventadetalles = result;
				
			}
		  );
		}

		function transition() {
		  $state.transitionTo($state.$current, {
		  });
		}

		// Date picker configuration
		function today() {
		  // Today + 1 day - needed if the current day must be included
		  var today = new Date();
		  vm.toDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate()
		  ); //+1 seria manana
		}

		function previousMonth() {
		  var fromDate = new Date();
		  if (fromDate.getMonth() === 0) {
			fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
		  } else {
			fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
		  }

		  vm.fromDate = fromDate;
		}
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'Ventasdetalle',
			  headers:false, 
			  caption: {
				  title:'Ventasdetalle',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};

		//		
		//
		alasql.fn.mydateformat = function(value) {
			if (value !== "") {
				const options = {
					timeZone:"America/Argentina/Buenos_Aires",
					hour12 : false,
					hour:  "2-digit",
					minute: "2-digit",
					second: "2-digit",
					year: "numeric",
					month:"2-digit",
					day:"2-digit"
				}
				return new Date(value).toLocaleTimeString("es-AR",options);
			} else {
		        return ""
            }
        };
				
		var dateFormat = "dd-MM-yyyy";
		var fechadesde = $filter("date")(vm.fromDate, dateFormat);
		var fechahasta = $filter("date")(vm.toDate, dateFormat);
		var nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
		var ncol_comercio="Comercio";
		var ncol_ip="Ip";
		var ncol_fecha="Fecha";
		var ncol_nroticket="Ticket";
		var ncol_esncredito="EsNCredito";
		var ncol_cliente="Cliente";
		var ncol_codigomoneda="Moneda";
		var ncol_factura="TipoFactura";
		var ncol_operacion="Operacion";
		var ncol_descripcion="Descripcion";
		var ncol_monto="Monto";
		var ncol_cantidad="Cantidad";
		var ncol_mdepcategoria="CategoriaMdeP";
		var ncol_categoria="Categoria";
				
		//Comercio	Pv	Ip	Fecha	Ticket	EsNCredito	Cliente	Factura	Operacion	Descripcion	Monto	Cantidad	CategoriaMdeP
		vm.exportDataExcel = function () {
			
			vm.vtadetallefiltrada = angular.copy(vm.ventadetalles.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtadetallefiltrada[0].comercio.replace(/\s+/g, '-') + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}
			
			alasql('select * INTO XLSX("Ventadetalle_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?,?,?, ?,?,?,? \
				union all select comercio,ip,mydateformat(fecha) as fecha,nroticket,esncredito,cliente,codigomoneda,tipofactura,operacion,descripcion,monto,cantidad, mdepcategoria, categoria FROM ?)', 
				[mystyle,ncol_comercio,ncol_ip,ncol_fecha,ncol_nroticket,ncol_esncredito,ncol_cliente,ncol_codigomoneda,ncol_factura,ncol_operacion,ncol_descripcion,ncol_monto,ncol_cantidad, ncol_mdepcategoria,ncol_categoria,vm.vtadetallefiltrada]);
		
			};
		
		vm.exportDataCSV = function () {
			
			vm.vtadetallefiltrada = angular.copy(vm.ventadetalles.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtadetallefiltrada[0].comercio.replace(/\s+/g, '-') + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}	
				
			alasql('select * INTO CSV("Ventadetalle_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?,?,?, ?,?,?,? \
				union all select comercio,ip,mydateformat(fecha) as fecha,nroticket,esncredito,cliente,codigomoneda, tipofactura,operacion,descripcion,monto,cantidad, mdepcategoria, categoria  FROM ?)', 
				[mystyle,ncol_comercio,ncol_ip,ncol_fecha,ncol_nroticket,ncol_esncredito,ncol_cliente,ncol_codigomoneda, ncol_factura,ncol_operacion,ncol_descripcion,ncol_monto,ncol_cantidad, ncol_mdepcategoria,ncol_categoria, vm.vtadetallefiltrada]);
			};	

			
		//para storage de Date's
		function dateReviver( key, value ) {
			if ( isSerializedDate( value ) ) {
				return( new Date( value ) );
			}
			// If it's not a date-string, we want to return the value as-is. If we fail to return
			// a value, it will be omitted from the resultant data structure.
			return( value );
		}


		// I determine if the given value is a string that matches the serialized-date pattern.
		function isSerializedDate( value ) {
			// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
			var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
			return( isString( value ) && datePattern.test( value ) );
		}

		// I determine if the given value is a String.
		function isString( value ) {
			return( {}.toString.call( value ) === "[object String]" );
		}

		
		function soloUnComercio()
		{
		if( !vm.seleccionComercio ||	!vm.seleccionComercio.length)
			return false;
		if("<Todos>" === vm.seleccionComercio)
			return false;
		return true;
		}
		

		$scope.calcTotal = function(comercio){
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return 0;
			if( !vm.ventadetalles ||	!vm.ventadetalles.length)
				return 0;
			
			vm.totalizado=0;
			var maxl=vm.ventadetalles.length;
			if("<Todos>" === $scope.vm.seleccionComercio){
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.ventadetalles[i];
					vm.totalizado += 1;
					}
				return vm.totalizado;
				}
			//
			for (var i = 0; i < maxl; i++) { 
				var zet = vm.ventadetalles[i];
				if(zet.comercio === $scope.vm.seleccionComercio){
					vm.totalizado += 1;
					}
				}
			return vm.totalizado;
		}
		

		
		$scope.filtraPorComercio = function (ventadetalle) {
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionComercio)
				return true;
			if(ventadetalle.comercio === $scope.vm.seleccionComercio)
				return true;
			return false;
		}
    }
})();